import { CardsViewAttributeOption, CardsViewSortOption } from "@organisms/ObjectsView/CardsView/CardsView.types"

export const ESTIMATE_CARDS_VIEW_ATTRIBUTE_OPTIONS: CardsViewAttributeOption<Estimate>[] = [
    { name: "total", label: "Total" },
    { name: "date_issued", label: "Issued" },
    { name: "terms", label: "Terms" },
    { name: "down_payment_status", label: "Down Payment" },
    { name: "last_modified_at", label: "Last Modified" },
    { name: "labels", label: "Labels" },
]

export const ESTIMATE_CARDS_VIEW_SORT_OPTIONS: CardsViewSortOption<Estimate>[] = [
    { name: "id", label: "ID" },
    { name: "client_name", label: "Client" },
    { name: "status_label", label: "Status" },
    { name: "total", label: "Total" },
    { name: "service_name", label: "Service" },
    { name: "service_location_name", label: "Location Name" },
    { name: "service_location_address", label: "Location Address" },
    { name: "date_issued", label: "Issued" },
    { name: "date_due", label: "Expires" },
    { name: "down_payment_status", label: "Down Payment" },
    { name: "last_modified_at", label: "Last Modified" },
    { name: "last_viewed", label: "Seen" },
    { name: "last_sent_at", label: "Sent" },
    { name: "last_approved_at", label: "Approved" },
    { name: "last_won_at", label: "Won" },
    { name: "last_lost_at", label: "Lost" },
    { name: "last_cancelled_at", label: "Cancelled" },
]
